import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import type { MinesweeperPresence } from "./Player";
import { registerMinesweeperTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  MinesweeperDefinition,
  MinesweeperProgress,
  MinesweeperSolution,
  MinesweeperSubmission,
} from "./types";

registerMinesweeperTranslations(i18n);

export const minesweeperModule: PuzzleTypeModule<
  MinesweeperDefinition,
  MinesweeperSubmission,
  MinesweeperProgress,
  MinesweeperSolution,
  MinesweeperPresence
> = {
  key: "minesweeper",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
